var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"problems-codeSection-layout"},[_c('code-view',{attrs:{"data":_vm.problemData,"loading":_vm.loading},on:{"run":_vm.runCode,"language-change":_vm.updateLanguage,"code-change":_vm.updateCode}}),_c('test-result-view',{attrs:{"output":_vm.output,"loading":_vm.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }